import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {HttpRequestService} from '../_common/http-request.service';

@Injectable()
export class IosAppUserService {

    constructor(private http: HttpRequestService) {
    }

    gets(parameters: any) {
        return this.http.get(`iosAppUsers`, parameters)
            .map(res => {
                return res.json();
            })
    }
    get(userId) {
        return this.http.get(`iosAppUser?id=${userId}`)
            .map(res => {
                return res.json();
            })
    }

    add(model: any) {
        return this.http.post(`addIosAppUser`,
            model).map(res => {
            return res.json();
        });
    }

    delete(id: string) {
        return this.http.delete(`deleteIosAppUser?id=${id}`).map(res => {
                return res.json();
            });
    }

    edit(model: any) {
        return this.http.post(`editIosAppUser`,
            model).map(res => {
                return res.json();
            });
    }

}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_services/ios-app-user.service.ts